import React from 'react';
import { motion } from 'framer-motion';
import { FileSignatureIcon, FlameIcon, RefreshCwIcon, HeartHandshakeIcon, ShieldIcon, CheckCheckIcon } from 'lucide-react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
const reasons = [{
  icon: FileSignatureIcon,
  text: 'You have been asked to sign something'
}, {
  icon: FlameIcon,
  text: 'A dispute is escalating'
}, {
  icon: RefreshCwIcon,
  text: 'You are buying, selling or restructuring'
}, {
  icon: HeartHandshakeIcon,
  text: 'Your family circumstances have changed'
}, {
  icon: ShieldIcon,
  text: 'You need to protect your estate, business or property'
}, {
  icon: CheckCheckIcon,
  text: 'You want the matter handled properly from the start'
}];
export function WhyContact() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-225">
      <Container data-id="element-226">
        <SectionHeading eyebrow="Why clients contact us" title="Get advice before the next step costs more." intro="Most legal problems are cheaper and easier to solve early. If any of these sound familiar, it's worth a conversation." data-id="element-227" />
        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-228">
          {reasons.map((r, i) => {
          const Icon = r.icon;
          return <motion.div key={r.text} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.04
          }} className="group flex items-start gap-4 bg-white p-6 transition-colors hover:bg-cream" data-id="element-229">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brass/10 text-brass-dark" data-id="element-230">
                  <Icon className="h-5 w-5" data-id="element-231" />
                </span>
                <p className="pt-1.5 text-[0.98rem] font-medium leading-snug text-navy" data-id="element-232">
                  {r.text}
                </p>
              </motion.div>;
        })}
        </div>
      </Container>
    </section>;
}